import React, { createContext, useContext, useState } from 'react';

const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [questionList, setQuestionList] = useState([]); // dados advindos do backend
  const [initialSetup, setInitialSetup] = useState({}); // dados advindos do backend
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [questionConfig, setQuestionConfig] = useState({});
  const [reportConfig, setReportConfig] = useState({
    pageTitle: null,
    clientName: null,
    sample: null,
    objective: null,
    field_period: null,
    error_margin: null,
    trust: null,
    method: null,
    considerations: null,
  })
  const [questionState, setQuestionState] = useState([]);

  return (
    <ReportContext.Provider value={{ 
      selectedQuestion, setSelectedQuestion, questionList, setQuestionList,
      questionConfig, setQuestionConfig, initialSetup, setInitialSetup,
      reportConfig, setReportConfig, questionState, setQuestionState
    }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReport = () => {
  return useContext(ReportContext);
};